module.exports = __webpack_public_path__ + "img/sh.67a544c.png";